import { useEffect, useRef, useState } from 'react';

export const useDelayUnmount = (isMounted: boolean, unmountDelay: number) => {
    const timeoutRef = useRef<NodeJS.Timeout | number | undefined>(undefined);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        if (isMounted && !shouldRender) {
            setShouldRender(true);
        } else if (!isMounted && shouldRender) {
            timeoutRef.current = setTimeout(() => setShouldRender(false), unmountDelay);
        }

        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, [isMounted, shouldRender, setShouldRender, timeoutRef, unmountDelay]);

    return shouldRender;
};

export const useModalRefs = () => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const portalRef = useRef<HTMLDivElement | null>(null);

    const mounted = useRef(true);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    return { modalRef, contentRef, portalRef, mounted };
};
